import { gql as gqlGraphqlRequest } from "graphql-request";

import { Gql, GqlObj, GqlObjectTransform } from "./types";
import { getOperationName } from "./operationName";

export const DEFAULT_GROUP = "default";

const camelToSnakeCase = (str: string): string =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

const booleanDirectiveTransform =
  (directive: keyof GqlObj["directives"]): GqlObjectTransform =>
  (gqlObj) => {
    const directiveTag = `@${camelToSnakeCase(directive)}`;
    const directiveValue = gqlObj.doc.includes(directiveTag);
    const doc = gqlObj.doc.replaceAll(directiveTag, "");
    return {
      ...gqlObj,
      directives: { ...gqlObj.directives, [directive]: directiveValue },
      doc,
    };
  };

const updateGroupTransform: GqlObjectTransform = (gqlObj) => {
  const groups = gqlObj.doc.match(/@update_groups\(groups:\s*"(.*)"\)/i);
  const doc = gqlObj.doc.replaceAll(/@update_groups\(.*\)/gi, "");

  return {
    ...gqlObj,
    doc,
    directives: {
      ...gqlObj.directives,
      groups:
        groups && groups[1]
          ? groups[1].split(",").map((group) => group.trim())
          : [DEFAULT_GROUP],
    },
  };
};

const transforms: GqlObjectTransform[] = [
  booleanDirectiveTransform("ignoreUpdate"),
  booleanDirectiveTransform("silent"),
  updateGroupTransform,
];

const composeTransforms: GqlObjectTransform = (gqlKey) =>
  transforms.reduce((key, transform) => transform(key), gqlKey);

export const gql: Gql = (...args) => {
  const doc = gqlGraphqlRequest(...args);
  return composeTransforms({
    directives: {},
    doc,
    operationName: getOperationName(doc),
    toString() {
      return this.doc;
    },
  });
};
